import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, timeout: 120000 });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("skillgap_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("skillgap_token");
    }
    // Intercept subscription/usage blocks so any page can trigger the modal
    // without duplicating logic. Backend returns 402 with a structured
    // `detail` object: { code, feature, feature_label, used, limit, message, redirect }.
    if (err?.response?.status === 402) {
      const d = err.response.data?.detail;
      if (d && typeof d === "object" && d.code) {
        try {
          window.dispatchEvent(new CustomEvent("skillgap:limit-reached", { detail: d }));
        } catch (_) { /* ignore */ }
      }
    }
    return Promise.reject(err);
  }
);

export default api;
